import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useCardProviderOptionsStore } from "@/employee/store/cardProviderOptions";
import { useUserCapabilitiesStore } from "@/employee/store/userCapabilities";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { CardProvider } from "@/shared/types";

export function canAccessDebitCardManagement (): boolean {
  const custodianSettingsStore = useCustodianSettingsStore();
  const cardProviderOptionsStore = useCardProviderOptionsStore();
  const userCapabilitiesStore = useUserCapabilitiesStore();
  const partnerPortalStore = usePartnerPortalStore();

  return (
    custodianSettingsStore.isHsaBankCustodian &&
    cardProviderOptionsStore.isLoaded &&
    cardProviderOptionsStore.capability.canManageCard &&
    cardProviderOptionsStore.cardProvider === CardProvider.Fiserv &&
    userCapabilitiesStore.cardManagementScreenVisible &&
    partnerPortalStore.hasActiveAccount
  );
}